<template>
    <v-snackbar
      v-model="preventaSnackbar.show"
      location="top"
      color="orange-darken-3"
      :timeout="4000"
      class="push-notification-snackbar"
      elevation="4"
      rounded="pill"
      density="compact"
    >
      <div class="d-flex align-center justify-center">
        <v-icon color="white" icon="mdi-calendar-check" class="mr-2" size="18"></v-icon>
        <div class="text-caption font-weight-bold text-white">
          {{ preventaSnackbar.message }}
        </div>
      </div>
    </v-snackbar>

    <v-snackbar
      v-model="snackbar2.show"
      :color="snackbar2.color"
      :timeout="3000"
      location="bottom"
    >
      {{ snackbar2.message }}
    </v-snackbar>


    <div class="main-scroll pb-20">


      <v-container fluid class="pa-0">
        <!-- ✅ Contenedor agregado -->

        <!-- ✅ Sección: Marcas -->
        <div class="text-center mt-2 mb-2">
          <span class="font-bold text-blue-darken-5 text-lg drop-shadow-md">
            Explora nuestras marcas
          </span>
        </div>

        <div class="marcas py-2">
     <div class="flex gap-4 overflow-x-auto px-2" style="scroll-behavior: smooth; white-space: nowrap; scrollbar-width: none;">
            <v-col v-for="(item, index) in transitions" :key="index" cols="auto"
              class="pa-0 flex flex-col items-center inline-block">
              <v-card :class="item.color" hover :width="$vuetify.display.smAndDown ? '75px' : '80px'"
                :height="$vuetify.display.smAndDown ? '75px' : '80px'" elevation="4" style="
                  border-radius: 50%; display: flex; align-items: center; justify-content: center;
                " @pointerdown="startPointer($event, item.route)" @pointerup="endPointer($event)">
                <v-img :src="item.image" :height="$vuetify.display.smAndDown ? '50px' : '55px'"
                  :width="$vuetify.display.smAndDown ? '50px' : '55px'" class="cursor-pointer" contain>
                  <template v-slot:placeholder>
                    <div class="d-flex align-center justify-center fill-height">
                      <v-progress-circular indeterminate color="grey-lighten-4" size="20"></v-progress-circular>
                    </div>
                  </template>
                </v-img>
              </v-card>

              <v-card-title class="product-title text-center font-medium" :style="{
                fontSize: $vuetify.display.smAndDown ? '11px' : '14px',
                paddingTop: '8px',
                color: '#1E3A8A',
              }">
                {{ item.name }}
              </v-card-title>
            </v-col>
          </div>
        </div>

        <!-- Categorías -->
        <!-- Categorías -->
        <div class="text-center my-2">
          <span class="font-bold text-blue-darken-5 text-sm drop-shadow-md">
            Categorías
          </span>
        </div>

        <div class="marcas py-1">
          <div class="flex gap-3 overflow-x-auto px-2" style="scroll-behavior: smooth; white-space: nowrap; scrollbar-width: none;">
            <v-col v-for="(item, index) in products" :key="index" cols="auto" class="pa-0 inline-block">
              <v-sheet @click="navigateTo(item.route)" class="d-flex align-center px-3 py-2 category-chip" elevation="2"
                rounded="xl">
                <v-img :src="item.image" width="36" height="36" class="mr-2" style="border-radius: 6px" />

                <span class="text-caption font-medium text-blue-darken-4">
                  {{ item.category }}
                </span>
              </v-sheet>
            </v-col>
          </div>
        </div>
        <!-- Botón del carrito flotante -->
        <!-- Botón flotante Media Caja -->
        <v-btn
          icon
          class="floating-halfbox-btn"
          :color="viewHalfBoxes ? 'orange-darken-3' : 'white'"
          @click="toggleHalfBoxes"
          elevation="10"
        >
          <v-icon :color="viewHalfBoxes ? 'white' : 'grey-darken-3'" size="26">
            {{ viewHalfBoxes ? 'mdi-package-variant-closed' : 'mdi-puzzle' }}
          </v-icon>
        </v-btn>

        <!-- Botón flotante tipo Didi/Rappi -->
        <v-btn icon class="floating-cart-btn" color="blue-darken-4" @click="openCart" elevation="10">
          <v-icon color="white" size="30">mdi-cart-outline</v-icon>
          <span v-if="totalCajas > 0" class="cart-badge">{{ totalCajas }}</span>
        </v-btn>
        <div class="text-center my-4">
          <span class="font-bold text-blue-darken-5 text-lg drop-shadow-md">
            Explora nuestros productos
          </span>
          <div class="mb-6">
            <div class="relative w-full max-w-md mx-auto">
              <input v-model="searchQuery" type="text" placeholder="Buscar productos"
                class="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400" />
              <br /><br />
              <p class="text-center text-xs md:text-sm text-gray-600 uppercase tracking-wider">
                Evita el exceso
              </p>
              <br />
              <span class="absolute left-3 top-2.5 text-gray-400">
                <i class="mdi mdi-magnify"></i>
              </span>
            </div>

            <!-- Carrusel de Marcas (Filtro Visual) -->
            <div v-if="brandList.length > 0" class="mb-2 mt-4">
              <div class="d-flex overflow-x-auto pb-2 px-1" style="gap: 16px; scrollbar-width: none; -ms-overflow-style: none;">
                <div
                  v-for="brand in brandList"
                  :key="brand.name"
                  class="d-flex flex-column align-center flex-shrink-0"
                  style="cursor: pointer; width: 85px;"
                  @click="toggleBrandFilter(brand.name)"
                >
                  <v-avatar
                    size="80"
                    :style="selectedBrands.includes(brand.name) ? 'border: 3px solid #1565C0; padding: 10px;' : 'border: 1px solid #E0E0E0; background-color: white; padding: 10px;'"
                  >
                    <v-img :src="brand.image" :cover="false" style="height: 100%; width: 100%;"></v-img>
                  </v-avatar>
                  <span
                    class="text-caption mt-1 text-center text-truncate w-100"
                    style="font-weight: 500; line-height: 1.1;"
                    :class="selectedBrands.includes(brand.name) ? 'text-blue-darken-4 font-weight-bold' : 'text-grey-darken-2'"
                  >
                    {{ brand.name }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ref="ofertadosContainer" class="pa-2">
          <!-- Buscador -->
          <!-- Productos -->
          <v-row dense class="pb-8">
            <v-col v-for="product in filteredOfertados" :key="product.id" cols="6" sm="6" md="4" lg="3"
              class="d-flex justify-center">
              <v-card class="pa-4" variant="flat" color="transparent" style="width: 240px">
                <v-row>
                  <div class="d-flex align-center" style="position: relative">
                    <!-- Bloque de botones dinámicos -->
                    <div v-if="getProductQuantity(getCartProduct(product)) > 0" class="d-flex align-center mt-2">
                      <!-- Botón disminuir / eliminar -->
                      <v-btn icon variant="text" @click="
                        handleDecrease(product)
                        " density="compact" :color="(getProductQuantity(getCartProduct(product)) === 1 || viewHalfBoxes) ? 'red' : 'orange-darken-1'
                          ">
                        <v-icon>
                          {{
                            (getProductQuantity(getCartProduct(product)) === 1 || viewHalfBoxes)
                              ? "mdi-delete"
                              : "mdi-minus-circle"
                          }}
                        </v-icon>
                      </v-btn>

                      <!-- Cantidad actual -->
                      <span class="px-2 text-caption font-weight-bold" style="font-size: 1.2em">
                        {{ getProductQuantity(getCartProduct(product)) }}
                      </span>

                      <!-- Botón aumentar -->
                      <v-btn icon variant="text" size="42" @click="viewHalfBoxes ? addPiecesToCart(product) : increaseQuantity(product)" density="compact" 
                        color="blue-darken-4" :disabled="product.id_promocion
                          ? getProductQuantity(getCartProduct(product)) >= 5
                          : false
                          ">
                        <v-icon>mdi-plus-circle</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-row>

                <v-row class="d-flex justify-center" style="position: relative">
                  <v-col cols="9" style="position: relative">
                    <!-- Imagen -->
                    <v-img :src="product.foto || 'default-image-url'" height="100px" class="rounded" :cover="false">
                      <template v-slot:placeholder>
                        <div class="d-flex align-center justify-center fill-height">
                          <v-progress-circular indeterminate color="grey-lighten-4" size="20"></v-progress-circular>
                        </div>
                      </template>
                    </v-img>
                    <!-- Icono de agregar (Normal) -->
                    <template v-if="!viewHalfBoxes">
                    <v-icon color="blue-darken-4" size="42" v-ripple class="add-icon" style="
                      position: absolute;
                      top: 5px;
                      right: 5px;
                      background: white;
                      border-radius: 50%;
                      padding: 2px;
                      cursor: pointer;
                    " :disabled="product.id_promocion
                      ? (product.promo_price > 0 && getProductQuantity(getCartProduct(product)) >= 1) // 🔒 Si tiene promo real, solo 1
                      : false
                      " @click="
                        ((product.id_promocion && product.promo_price > 0 && getProductQuantity(getCartProduct(product)) < 1) ||
                          (!product.id_promocion || product.promo_price <= 0)) &&
                        (viewHalfBoxes ? addPiecesToCart(product) : addToCart(product))
                        " :class="{
                        'v-icon--disabled': product.id_promocion
                          ? (product.promo_price > 0 && getProductQuantity(getCartProduct(product)) >= 1)
                          : false,
                      }" :style="getProductQuantity(getCartProduct(product)) > 0 
                      ? 'pointer-events: none; opacity: 0;'
                      : ''
                      ">
                      mdi-plus-circle
                    </v-icon>
                    </template>

                    <!-- Botón PZA (Media Caja) -->
                    <template v-else>
                      <div
                        v-ripple
                        class="add-icon d-flex align-center justify-center"
                        style="
                          position: absolute;
                          top: 5px;
                          right: 5px;
                          background: white;
                          border-radius: 50%;
                          width: 42px;
                          height: 42px;
                          cursor: pointer;
                          border: 2px solid #0D47A1;
                          transition: opacity 0.2s;
                        "
                        @click="addPiecesToCart(product)"
                        :style="getProductQuantity(getCartProduct(product)) > 0
                          ? 'pointer-events: none; opacity: 0;'
                          : ''
                        "
                      >
                        <span class="text-blue-darken-4 font-weight-bold" style="font-size: 12px;">
                          PZA
                        </span>
                      </div>
                    </template>
                  </v-col>
                </v-row>

                <!-- Precio / Promo -->
                <div class="w-full text-center mt-4 p-3 transition-shadow duration-300 space-y-1">
                  <template v-if="product.id_promocion && product.promo_price > 0 && !viewHalfBoxes">
                    <div class="text-gray-500 line-through font-semibold">
                      ${{ parseFloat(product.price).toFixed(2) }}
                    </div>
                    <div class="text-base sm:text-lg md:text-xl font-semibold text-red">
                      ${{
                        (
                          product.price -
                          (product.price * product.promo_price) / 100
                        ).toFixed(2)
                      }}
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-base sm:text-lg md:text-xl font-semibold text-blue-700">
                      ${{ parseFloat(getDisplayPrice(product)).toFixed(2) }}
                    </div>
                  </template>

                  <!-- Nombre -->
                  <div class="text-xs sm:text-sm md:text-base font-medium text-gray-700">
                    {{ product.nombre }}
                  </div>

                  <!-- SKU -->
                  <div class="text-xs sm:text-sm font-medium text-gray-400">
                    SKU: {{ product.sku }}
                  </div>

                  <!-- Distintivo de promoción -->
                  <div v-if="product.id_promocion && product.promo_price > 0"
                    class="mt-1 inline-block px-2 py-1 bg-green-500 text-white text-xs font-bold rounded-full">
                    Descuento {{ product.promo_price }}%
                  </div>

                  <!-- Agotado -->
                  <div v-if="product.yfr_disponible <= 0" class="text-sm sm:text-base font-semibold text-red-500">
                    Agotado
                  </div>

             
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <!-- Dialogo del carrito -->
        <CartDialog v-model="cartDialog" />
        <!-- Navegación inferior -->
      </v-container>
      <!-- ✅ Cierre del contenedor -->
    </div>
 
</template>


<style>
html,
body,
#app {
  height: 100%;
  overflow: hidden;
  /* Capacitor lo necesita */
  overscroll-behavior-y: contain; /* Evita recarga pull-to-refresh global */
}

.v-application {
  height: 100vh;
}

.main-scroll {
  height: calc(100vh - (64px + env(safe-area-inset-top, 30px)));
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain; /* Evita recarga pull-to-refresh en la lista */
}

.category-chip {
  min-height: 44px;
  background: #ffffff;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.category-chip:active {
  transform: scale(0.96);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

/* ===== CONTENEDOR PRINCIPAL ===== */
.main-content {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  /* se apilan secciones en móvil */
  align-items: center;
  justify-content: flex-start;
  padding: calc(env(safe-area-inset-top) + 20px) 0 calc(env(safe-area-inset-bottom) + 20px) 0;
  background-color: #f9f9f9;
}

/* Ajuste para que la notificación parezca Push (debajo del AppBar) */
.push-notification-snackbar {
  margin-top: 10px !important; /* La subimos más arriba */
  z-index: 10000 !important;   /* 🔥 CRÍTICO: Asegura que flote sobre TODO (marcas, appbar, etc) */
}

.floating-halfbox-btn {
  position: fixed;
  bottom: 220px; /* Ajustado para estar arriba del carrito (150px + 60px + gap) */
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
</style>


<script setup>
import { ref, shallowRef, computed, onMounted, onActivated, inject } from "vue";
import { useRouter } from "vue-router";
import CartDialog from "./Administrador/CarritoViewStore.vue";
import api from "@/services/api";
import Swal from "sweetalert2";
import { useUserStore } from "../stores/userStore";
import { Preferences } from "@capacitor/preferences";

// eslint-disable-next-line no-undef
defineOptions({
  name: 'MarcasXProductoView'
});

const CACHE_KEY = "ofertados_cache";
const CACHE_TIME_KEY = "ofertados_cache_time";
const CACHE_TTL = 15 * 60 * 1000; // 15 min

const router = useRouter();
const userStore = useUserStore();
const cartStore = inject("cartStore");

if (!cartStore) {
  throw new Error("cartStore is not provided");
}

const { addToCart, increaseQuantity, decreaseQuantity, getProductQuantity, removeFromCart } = cartStore;

// --- Estado Reactivo ---
const searchQuery = ref("");
const cartDialog = ref(false);

const ofertados = shallowRef([]); // 🚀 Optimización de rendimiento
const brandList = shallowRef([]); // 🚀 Optimización de rendimiento
const selectedBrands = ref([]);
const viewHalfBoxes = ref(false);
const preventaSnackbar = ref({ show: false, message: "" });
const snackbar2 = ref({ show: false, message: "", color: "info" });
const suggestedItems = ref([]);

// --- Datos Estáticos (No necesitan ser reactivos profundos si no cambian) ---
const transitions = [
  { image: "https://grupomv.mx/images/2025/productos/mvexpress/fotos/logopenafiel.png", color: "bg-white", route: "/101List", name: "Peñafiel" },
  { image: "https://tse1.mm.bing.net/th/id/OIP.bitvkpzf9GG5YUV-oC1OmQHaEK?rs=1&pid=ImgDetMain&o=7&rm=3", color: "bg-white", route: "/139-suprema", name: "Kellogs" },
  { image: "https://i0.wp.com/lfa.mx/2018/wp-content/uploads/2018/02/electrolit-logo.png?fit=600%2C600&ssl=1", color: "bg-white", route: "/101-ElectrolitView", name: "Electrolit" },
  { image: "https://th.bing.com/th/id/OIP.t2Gbf1ArhYU5L2AKNUHZpQHaFI?rs=1&pid=ImgDetMain", color: "bg-black", route: "/101-JackDanielsView", name: "Jack Daniel's" },
  { image: "https://grupomv.mx/images/logos/10.png", color: "bg-deep-purple-darken-4", route: "/101-NewMix", name: "New Mix" },
     { image: "https://th.bing.com/th/id/OIP.JE5lQeQFTIDRx7xOAWzt6QAAAA?rs=1&pid=ImgDetMain", color: "bg-white", route: "/103-redbull", name: "Red Bull" },
  { image: "https://http2.mlstatic.com/D_Q_NP_640619-MLA28280782002_102018-F.jpg", color: "bg-white", route: "/101-CaribeCoolerView", name: "Caribe Cooler" },
  { image: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/0013/6452/brand.gif?itok=bBsc-K9p", color: "bg-white", route: "/101-BoonesView", name: "Boones" },
  { image: "https://sitecoreaudioprod.umusicpub.com/sitecore_media/1B01EEBD-C4B8-4C75-8E79-C7F0131FC0DA.jpg", color: "bg-amber", route: "/101-vuala", name: "Vualá" },
  { image: "https://www.clamato.com/img/clamato-logo-large.png", color: "bg-red", route: "/101-ClamatoView", name: "Clamato" },
  { image: "https://www.nissinfoods.com/wp-content/uploads/2023/03/cup-noodles-nissin-1.png", color: "bg-white", route: "/141-nissin", name: "Nissin" },
];

const products = [
  { brand: "Refrescos", category: "Refrescos", image: "https://m.media-amazon.com/images/I/61tArldLWVL._AC_UF350,350_QL80_.jpg", route: "/101List" },
  { brand: "Energetizantes", category: "Energetizantes", image: "https://mir-s3-cdn-cf.behance.net/project_modules/1400/74fd09177758701.64dc4a81f1ab3.png", route: "/100-EnergetizantesView" },
  { brand: "Preparadas", category: "Tequila", image: "https://m.media-amazon.com/images/I/71ykFJMiUZL.jpg", route: "/101-NewMix" },
  { brand: "Clamato", category: "Bebidas", image: "https://m.media-amazon.com/images/I/815-WNfqyJL.jpg", route: "/101-ClamatoView" },
];



// --- Computed ---
const totalCajas = computed(() =>
  cartStore.state.cart.reduce((total, item) => total + item.quantity, 0)
);

const filteredOfertados = computed(() => {
  const query = searchQuery.value.toLowerCase().trim();
  let result = ofertados.value;

  if (viewHalfBoxes.value) {
    result = result.filter((p) => canSellPieces(p));
  }

  if (selectedBrands.value.length > 0) {
    result = result.filter(p => selectedBrands.value.includes(p.sublinea || p.marca));
  }

  if (!query) return result;

  return result.filter((product) =>
    [product.nombre, product.marca, product.category].some(
      (field) => field && field.toLowerCase().includes(query)
    )
  );
});

// --- Métodos ---
const toggleBrandFilter = (brandName) => {
  if (selectedBrands.value.includes(brandName)) {
    selectedBrands.value = [];
  } else {
    selectedBrands.value = [brandName];
  }
};

const updateBrandList = () => {
  const uniqueBrands = new Map();
  ofertados.value.forEach(p => {
    const brandName = p.sublinea || p.marca;
    if (brandName && !uniqueBrands.has(brandName)) {
      uniqueBrands.set(brandName, p.foto || 'https://grupomv.mx/images/logo2.png');
    }
  });
  
  let list = Array.from(uniqueBrands, ([name, image]) => ({ name, image }));

  const customOrder = ["PENSAB", "CLAMAT", "SQUIRT", "DR PEPPER", "AGUA MINERAL"];

  list.sort((a, b) => {
    const indexA = customOrder.indexOf(a.name.toUpperCase());
    const indexB = customOrder.indexOf(b.name.toUpperCase());

    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    return a.name.localeCompare(b.name);
  });

  brandList.value = list;
};

const getDisplayPrice = (product) => {
  if (viewHalfBoxes.value) {
    const pieces = parseInt(product.PRODUC_PZAMINVTA || 0);
    const conversion = parseFloat(product.PRODUC_FACTCONVER3 || 1);
    if (conversion === 0) return product.price;

    // 🔥 Calcular precio con descuento si existe
    let finalPrice = parseFloat(product.price);
    if (product.id_promocion && product.promo_price) {
      finalPrice = finalPrice - (finalPrice * (product.promo_price / 100));
    }
    return (finalPrice / conversion) * pieces;
  }
  return product.price;
};

const getCartProduct = (product) => {
  if (viewHalfBoxes.value) {
    return {
      ...product,
      id: product.id ? `${product.id}_PZA` : undefined,
      sku: `${product.sku}-PZA`,
    };
  }
  return product;
};

const canSellPieces = (product) => {
  const conversion = parseFloat(product.PRODUC_FACTCONVER3 || 0);
  const minPieces = parseInt(product.PRODUC_PZAMINVTA || 0);
  return (
    product.pround &&
    ['CJA', 'CAJA'].includes(product.pround.toUpperCase()) &&
    conversion > 0 &&
    minPieces > 1 &&
    minPieces < conversion
  );
};

const addPiecesToCart = (product) => {
  const pieces = parseInt(product.PRODUC_PZAMINVTA || 0);
  const conversion = parseFloat(product.PRODUC_FACTCONVER3);
  
  // 🔥 Calcular precio con descuento si existe
  let finalPrice = parseFloat(product.price);
  if (product.id_promocion && product.promo_price) {
    finalPrice = finalPrice - (finalPrice * (product.promo_price / 100));
  }
  const piecePrice = finalPrice / conversion;

  const pzaProduct = {
    ...product,
    id: product.id ? `${product.id}_PZA` : undefined,
    producto_id: product.producto_id ? `${product.producto_id}_PZA` : undefined,
    sku: `${product.sku}-PZA`,
    nombre: `${product.nombre} (${pieces} PZA)`,
    pround: 'PZA',
    price: piecePrice,
    foto: product.proveedor_desc1 || product.foto,
    yfr_disponible: (product.yfr_disponible || 0) * conversion,
    id_promocion: null,
    promo_price: null,
    isLocked: true
  };

  for (let i = 0; i < pieces; i++) {
    addToCart(pzaProduct);
  }
};

const handleDecrease = async (product) => {
  const cartProduct = getCartProduct(product);
  const quantity = getProductQuantity(cartProduct);

  if (viewHalfBoxes.value || quantity === 1) {
    if (viewHalfBoxes.value) {
      const result = await Swal.fire({
        title: '¿Eliminar Media Caja?',
        text: "Se eliminarán todas las piezas del carrito.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      });
      if (!result.isConfirmed) return;
    }
    removeFromCart(cartProduct);
  } else {
    decreaseQuantity(cartProduct);
  }
};

const toggleHalfBoxes = () => {
  viewHalfBoxes.value = !viewHalfBoxes.value;
  if (viewHalfBoxes.value) {
    snackbar2.value = { show: true, message: "Modo Media Caja Activado", color: "info" };
  } else {
    snackbar2.value = { show: true, message: "Modo Caja Activado", color: "success" };
  }
};

const openCart = () => {
  cartDialog.value = true;
  suggestedProducts();
};

const suggestedProducts = async () => {
  try {
    const res = await api.get("/productos/suggested-products");
    suggestedItems.value = res.data ?? [];
  } catch (err) {
    console.error("Error fetching suggested products:", err);
  }
};

const navigateTo = (route) => {
  router.push(route);
};

// Pointer logic for carousel
let startX = 0;
let startY = 0;
let tappingRoute = null;

const startPointer = (e, route) => {
  startX = e.clientX;
  startY = e.clientY;
  tappingRoute = route;
};

const endPointer = (e) => {
  const dx = Math.abs(e.clientX - startX);
  const dy = Math.abs(e.clientY - startY);
  const tolerance = 5;
  if (dx < tolerance && dy < tolerance && tappingRoute) {
    navigateTo(tappingRoute);
  }
  tappingRoute = null;
};

// Cache Logic
const getOfertadosCache = async () => {
  const cached = await Preferences.get({ key: CACHE_KEY });
  const cachedTime = await Preferences.get({ key: CACHE_TIME_KEY });

  if (!cached.value || !cachedTime.value) return null;

  const age = Date.now() - Number(cachedTime.value);

  if (age > CACHE_TTL) {
    await Preferences.remove({ key: CACHE_KEY });
    await Preferences.remove({ key: CACHE_TIME_KEY });
    return null;
  }

  return JSON.parse(cached.value);
};

const saveOfertadosCache = async (data) => {
  await Preferences.set({ key: CACHE_KEY, value: JSON.stringify(data) });
  await Preferences.set({ key: CACHE_TIME_KEY, value: Date.now().toString() });
};

const fetchOfertados = async () => {
  try {
    const cached = await getOfertadosCache();
    if (cached) {
      ofertados.value = cached;
      updateBrandList();
      return;
    }

    const response = await api.get("/productos/100-ofertar");
    ofertados.value = response.data;
    updateBrandList();
    await saveOfertadosCache(response.data);
  } catch (error) {
    console.error("Error al obtener promociones:", error);
  }
};

const obtenerNuevaData = async () => {
  try {
    const user = userStore.user;
    if (!user?.id) return;
    const response = await api.get(`/get-mvcoins/${user.id}`);
    userStore.user = { ...userStore.user, ...response.data };
  } catch (error) {
    console.error("Error al obtener los datos del usuario:", error);
  }
};

const verificarPolitica = async () => {
  await obtenerNuevaData();
  if (!userStore.user?.politica_privacidad_aceptada) {
    alert("Debes aceptar el aviso de privacidad antes de continuar.");
    router.replace("/aviso-privacidad");
  }
};

let isFirstLoad = true;

// Lifecycle
onActivated(async () => {
  if (isFirstLoad) return;
  await fetchOfertados();
});

onMounted(async () => {
  if (!userStore.isSessionReady) {
    await userStore.initSession();
  }

  if (!userStore.isAuthenticated) {
    router.replace("/login");
    return;
  }

  await fetchOfertados();
  await verificarPolitica();

  isFirstLoad = false;

  // 🕒 Retrasar la notificación para evitar "jank" (trabones) durante la carga inicial de productos
  setTimeout(() => {
    // 🛑 VALIDACIÓN: Si ya se mostró en esta sesión, no molestar más
    if (sessionStorage.getItem("dias_pedido_mostrado")) return;

    const user = userStore.user;
    if (user && Array.isArray(user.direcciones) && user.direcciones.length > 0) {
      const direccionesConCoords = user.direcciones.filter(d => d.coordenadas_x && d.coordenadas_y);
      const direccionesAUsar = direccionesConCoords.length > 0 ? direccionesConCoords : [user.direcciones[0]];
      const dir = direccionesAUsar[0];
      const perfil = dir.CTEPFR_CODIGO_K || user.CTEPFR_CODIGO_K || "GENERAL";

      if (dir.dia) {
        preventaSnackbar.value = {
          show: true,
          message: `🗓️ (${perfil}) Tus días de pedido son: ${dir.dia}`
        };
        // ✅ Guardamos que ya se mostró para que no salga de nuevo hasta que cierre sesión
        sessionStorage.setItem("dias_pedido_mostrado", "true");
      }
    }
  }, 1500); // 1.5 segundos de espera para suavizar la experiencia
});
</script>
